import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import {
  NgModule,
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
} from "@angular/core";
import { FormsModule } from "@angular/forms";
import { HttpClientModule } from "@angular/common/http";
import { TranslateModule } from "@ngx-translate/core";

import { MatMenuModule } from "@angular/material/menu";
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatToolbarModule } from '@angular/material/toolbar';

import { MatDialogModule } from "@angular/material/dialog";

import { CoreModule } from "./core/core.module";
import { SharedModule } from "./shared/shared.module";
import { OauthModule } from "./core/authentication/oauth/oauth.module";
import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { SpOverviewModule } from "./components/sp-overview/sp-overview.module";
import { SpVersionModule } from "./components/sp-version/sp-version.module";
import { SpSupportModule } from "./components/sp-support/sp-support.module";
import { SpUserdialogComponent } from "./components/sp-userdialog/userdialog.component";
import { BaseAPIService } from "./shared/services/api.base.service";
import { RouterModule, Routes } from "@angular/router";
import { ToastrModule } from "ngx-toastr";
import { JwtModule } from "@auth0/angular-jwt";
import { TermsComponent } from "./components/terms/terms.component";
import { DataService } from "./shared/services/data.service";
import { SpMigrationExpertModule } from "./components/sp-migration-expert/sp-migration-expert.module";
import { SpHmiconverterModule } from "./components/sp-hmi-converter/sp-hmi-converter.module";
import { AdminDashboardModule } from "./components/admin-dashboard/admin-dashboard.module";
import { ServiceWorkerModule } from '@angular/service-worker'; 
export function jwtTokenGetter() {
  return sessionStorage.getItem("token");
}

const routes: Routes = [];

@NgModule({
    imports: [
        BrowserModule,
        BrowserAnimationsModule,
        RouterModule.forRoot(routes),
        AppRoutingModule,
        FormsModule,
        SharedModule,
        OauthModule,
        HttpClientModule,
        CoreModule,
        MatMenuModule,
        MatButtonModule,
        MatIconModule,
        MatToolbarModule,
        MatSidenavModule,
        MatListModule,
        MatDialogModule,
        SpOverviewModule,
        SpVersionModule,
        SpSupportModule,
        SpMigrationExpertModule,
        SpHmiconverterModule,
        AdminDashboardModule,
        TranslateModule.forRoot(),
        ToastrModule.forRoot({
          positionClass: 'toast-top-center'
        }),
        JwtModule.forRoot({
            config: {
                tokenGetter: jwtTokenGetter,
                allowedDomains: ["localhost:4200"],
            },
        }),
        ServiceWorkerModule.register('ngsw-worker.js', {
          enabled: true,
          // Register the ServiceWorker as soon as the application is stable
          // or after 30 seconds (whichever comes first).
          registrationStrategy: 'registerWhenStable:30000'
        }),
    ],
    exports: [SpUserdialogComponent],
    declarations: [
        AppComponent,
        SpUserdialogComponent,
        TermsComponent,
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
    providers: [BaseAPIService, DataService],
    bootstrap: [AppComponent]
})
export class AppModule {}
